// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Breadcrumbs_wrap_lvRf6","contents":"Breadcrumbs_contents_lCliT"};